import { Component, OnInit } from '@angular/core';
import { RouteValidationService } from 'apps/wsg/src/app/authorization/route-validation.service';
import { LandingPageLink } from './landing-page-link';

@Component({
  selector: 'wsg-generic-landing-page',
  templateUrl: './generic-landing-page.component.html',
  styleUrls: ['./generic-landing-page.component.css']
})
export class GenericLandingPageComponent implements OnInit {

  links: LandingPageLink[];

  constructor(protected routeValidationService: RouteValidationService) { }

  ngOnInit() {
  }

  validateRoute(path: string): boolean {
    return this.routeValidationService.validateRoute(path);
  }
}
